import React, { Component } from 'react';
import { compose } from "redux";

import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import faTimes from "@fortawesome/fontawesome-pro-light/faTimes";
import faCheck from "@fortawesome/fontawesome-pro-light/faCheck";

import withLocalize from "../../withLocalize";

class RoomTypeAvailability extends Component {
	render() {
		const { date, value, max, onClick, translate: t } = this.props;

		return (
			<div
				className={`room-type-availability ${value <= 0 ? 'room-type-availability--none' : (value >= max ? 'room-type-availability--full' : 'room-type-availability--some')}`}
				data-for="tooltip-occupancies"
				data-html={true}
				data-tip={t('Occupancies.RoomTypeAvailability.tooltip', { date: date.format('dd, D. M. YYYY'), count: value, totalCount: max })}
			>
				<button
					disabled={value <= 0}
					onClick={onClick}
				>
					{value <= 0 &&
					<FontAwesomeIcon icon={faTimes} />
					}
					{value > 0 && value < max &&
					value
					}
					{value >= max && max > 0 &&
					<FontAwesomeIcon icon={faCheck} />
					}
				</button>
			</div>
		);
	}
}

export default compose(
	withLocalize,
)(RoomTypeAvailability);



// WEBPACK FOOTER //
// ./src/components/Occupancies/RoomTypeAvailability.jsx